.live {
	display: flex;
	flex-direction: column;
	gap: var(--spacing-4);
	inline-size: 100%;

	.loadMore {
		display: flex;
		justify-content: center;
		padding-block: var(--spacing-2);
	}
}
